import { PropsWithChildren } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../modules/auth";

const AdminProtectedRoute = ({ children }: PropsWithChildren<{}>) => {
    const { currentUser } = useAuth();
    if (currentUser?.s_tipo !== 'AM') {
        return <Navigate to="/dashboard" replace />;
    }

    return <>{children}</>;
};

export default AdminProtectedRoute;